import { Link } from "react-router-dom";
import { Spinner, Table } from "react-bootstrap";

import "../../style/OrderHistorial.css";
import axios from "axios";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { addComasToPrice } from "../../utils/PriceFormat";

const OrderItems = () => {
  const { id } = useParams();

  const [orderItems, setOrderItems] = useState([]);
  const [loadingOrder, setLoadingOrder] = useState(false);

  useEffect(() => {
    setLoadingOrder(true);
    axios
      .get(`https://the-green-shop.herokuapp.com/api/orderItem/getAll/${id}`)
      .then((res) => {
        setOrderItems(res.data);
        setLoadingOrder(false);
      })
      .catch((error) => {
        setLoadingOrder(false);
        console.log(`server error: ${error}`);
      });
  }, [id]);

  return orderItems[0] ? (
    <div className="">
      {loadingOrder && (
        <div style={{ textAlign: "center" }}>
          <Spinner animation="border" variant="secondary" />
        </div>
      )}
      {!loadingOrder && (
        <>
          {/* {Mobile items} */}
          <div className="mobile-items2">
            {orderItems.map((item, i) => (
              <div
                key={item.id}
                style={{ display: "flex", padding: "5px 0", marginTop: "10px" }}
              >
                <div>
                  <Link to={`/product/${item.productId}`}>
                    <img
                      className="order-card-img"
                      alt=""
                      src={item.product.img[0]}
                    />
                  </Link>
                </div>
                {/* <div style={{ flex: 1 }}> */}
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ fontSize: "1.1em", fontWeight: "500" }}>
                    {item.product.name}
                  </div>
                  <div style={{ margin: "5px 0" }}>
                    $ {addComasToPrice(item?.product.price)}
                  </div>
                  <div
                    style={{
                      margin: "5px 0",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        padding: "5px 0",
                        display: "inline-block",
                        height: "32.4px",
                      }}
                    >
                      Quantity: {item.quantity}
                    </span>
                  </div>
                  <div style={{ margin: "5px 0" }}>
                    $
                    {addComasToPrice(
                      (item?.product.price * item.quantity).toFixed(2)
                    )}
                  </div>
                  {/* </div> */}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  ) : null;
};

export default OrderItems;
